








































































































































































































import { ITemplateContext } from "@/lib/interfaces/template/templateContext.interface";
import {
  displayMsAsMinutesAndHours,
  formatAsFullDateAndFullHour,
  formatHoursAndMinutes,
  formatYearsMonthDay,
  simpleDoubleDigitDate
} from "@/lib/utility/date-helper";
import { GoToHelper } from "@/lib/utility/goToHelper";
import { handleError } from "@/lib/utility/handleError";
import { BookingBookingDetailViewModelGen } from "@/services/booking/v1/data-contracts";
import { BookingModule } from "@/store/modules/booking.store";
import { PartnerModule } from "@/store/modules/partner";
import { ResourceModule } from "@/store/modules/resource.store";
import BookingForm, { BookingDto } from "@/views/booking/BookingForm.vue";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import TemplateDialog from "../template/TemplateDialog.vue";
import ConfirmActionDialog from "../utility/ConfirmActionDialog.vue";
import NumberplateForm from "@/components/utility/NumberplateForm.vue";
import BookingAttachmentList from "./BookingAttachmentList.vue";

@Component({
  components: { ConfirmActionDialog, BookingForm, TemplateDialog, NumberplateForm, BookingAttachmentList },
  filters: { simpleDoubleDigitDate, formatAsFullDateAndFullHour, formatHoursAndMinutes, displayMsAsMinutesAndHours }
})
export default class BookingDetailCard extends Vue {
  @Prop()
  booking!: BookingBookingDetailViewModelGen;

  @Prop()
  resourceName!: string;

  @Prop()
  serviceName!: string;

  @Prop()
  closeButton!: boolean;

  @Prop()
  fromCalendar!: boolean;

  @Watch("booking")
  watchBooking() {
    this.updateBookingDto = new BookingDto(this.booking);
  }

  updateBookingDto = new BookingDto(this.booking);

  isEdit = false;
  isLoading = false;

  isDialogActive = false;

  /**
   * Opening delete confirmation
   */
  isDeleteDialogActive = false;
  isDeleteDialogLoading = false;
  notifyUserForDelete = false;

  /**
   * Opening update confirmation
   */
  isUpdateDialogActive = false;
  isUpdateDialogLoading = false;
  notifyUserForUpdate = false;

  get resources() {
    return Array.from(ResourceModule.resourceLookup.values());
  }

  get serviceDetailRouterLinkData() {
    const toObject = {
      name: "ServiceDetail",
      params: { partnerId: this.booking.partnerId, serviceId: this.booking.serviceId }
    };

    if (this.fromCalendar) {
      toObject["query"] = { from: "calendar" };
    }

    return toObject;
  }

  get resourceDetailRouterLinkData() {
    const toObject = {
      name: "ResourceDetail",
      params: { partnerId: this.booking.partnerId, resourceId: this.booking.resourceId }
    };

    if (this.fromCalendar) {
      toObject["query"] = { from: "calendar" };
    }

    return toObject;
  }

  get startDate() {
    return new Date(this.booking?.start);
  }

  get startDateString() {
    return formatYearsMonthDay(this.startDate);
  }

  get startTimeString() {
    return formatHoursAndMinutes(this.startDate);
  }

  get duration() {
    return displayMsAsMinutesAndHours(this.booking.end - this.booking.start);
  }

  get endDate() {
    return new Date(this.booking?.end);
  }

  get endDateString() {
    return formatYearsMonthDay(this.endDate);
  }

  get endTimeString() {
    return formatHoursAndMinutes(this.endDate);
  }

  get partnerId() {
    return this.$route.params.partnerId;
  }

  get width() {
    return this.$vuetify.breakpoint.mobile ? "" : 500;
  }

  get partner() {
    return PartnerModule.partner;
  }

  get context(): ITemplateContext {
    return {
      customer: {
        id: "",
        firstName: this.booking.customerInformation?.firstName || "",
        lastName: this.booking.customerInformation?.lastName || "",
        userName: this.booking.customerInformation?.email || ""
      },
      partner: this.partner
    };
  }

  get bookingCancelled() {
    return this.booking.isDeleted;
  }

  close() {
    this.$emit("close");
  }

  goToResource() {
    new GoToHelper(this.$router).goToResourceDetail(this.booking.partnerId, this.booking.resourceId);
  }

  goToService() {
    if (!this.booking.serviceId) {
      this.$toast.error("Service ID not found");

      return;
    }

    new GoToHelper(this.$router).goToServiceDetail(this.booking.partnerId, this.booking.serviceId);
  }

  async deleteBooking() {
    this.isDeleteDialogLoading = true;

    try {
      await BookingModule.removeOneByPartner({
        partnerId: this.partnerId,
        id: this.booking.id,
        userNotification: this.notifyUserForDelete
      });
      this.$toast.success("👍");

      this.$emit("reload");
      this.$emit("close");
    } catch (error) {
      handleError(error);
    } finally {
      this.isDeleteDialogLoading = false;
      this.isDeleteDialogActive = false;
      this.notifyUserForDelete = false;
    }
  }

  async onUpdateBookingClicked() {
    /** End-user booking */
    if (this.booking.customerInformation && this.booking.customerInformation.email) {
      this.isUpdateDialogActive = true;
      return;
    }

    await this.updateBooking();
  }

  async updateBooking() {
    this.isUpdateDialogLoading = true;
    this.isLoading = true;

    try {
      await BookingModule.updateOneByPartner({
        query: {
          partnerId: this.partnerId,
          id: this.booking.id,
          userNotification: this.notifyUserForUpdate
        },
        data: {
          ...this.updateBookingDto.updateDto()
        }
      });

      this.$toast.success("👍");

      this.isEdit = false;
      this.$emit("reload");
      this.$emit("close");
    } catch (error) {
      handleError(error);
    } finally {
      this.isUpdateDialogLoading = false;
      this.isUpdateDialogActive = false;
      this.isLoading = false;
      this.notifyUserForUpdate = false;
    }
  }
}
